import { getTableSections, TableFlyoutSections } from './getSections';
import { computedFn } from 'mobx-utils/lib/computedFn';
import type { EditorViewState } from 'owa-editor';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { createAppFlyoutAnchor } from 'owa-command-ribbon';
import { getDefaultRibbonStyles } from 'owa-command-ribbon-styles/lib/util/getDefaultRibbonStyles';
import type { IKeytipProps } from '@fluentui/react/lib/Keytip';
import loc from 'owa-localize';
import { tableText } from '../../../utils/actionControlStrings.locstring.json';
import Table from 'owa-fluent-icons-svg/lib/icons/TableRegular';

export const getTableControl = computedFn(
    (
        id: string | number,
        viewState: EditorViewState | undefined,
        tooltip: string | undefined,
        keytip: IKeytipProps | undefined,
        isButtonDisabled: boolean
    ): RibbonControlProps => {
        const label = loc(tableText);
        const tableSections: TableFlyoutSections = getTableSections(
            id,
            viewState,
            label,
            Table,
            tooltip,
            keytip,
            isButtonDisabled
        );

        return createAppFlyoutAnchor(
            id,
            label,
            { sections: tableSections.menuSections },
            keytip,
            Table,
            undefined /*iconColors*/,
            getDefaultRibbonStyles(),
            {
                customTooltip: tooltip,
                disabled: isButtonDisabled,
            }
        );
    }
);
